import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { ROUTES } from '@/checkout-instore-legacy/constants/RoutesConstants'
import { isClientComplete } from '../utils'

const InsightsNotificationBar = ({ profile, router, openCart }) => {
  return (
    (isClientComplete(profile) || openCart) && (
      <div className="w-100 flex justify-center pt5">
        <div className="enter-from-above w-70-l w-70-m w-90 br2 bg-base mid-gray flex items-center pa5 ba b--light-gray z-5 f6 f5-ns">
          <div className="mr4">
            {isClientComplete(profile) ? (
              openCart ? (
                <FormattedMessage id="insightsNotificationBarCartFound" />
              ) : (
                <FormattedMessage id="insightsNotificationBarGeneric" />
              )
            ) : (
              openCart && <FormattedMessage id="openCartFound" />
            )}
          </div>
          <div
            className="c-action-primary ml-auto bn pointer"
            id="insights-cta"
            data-testid="insights-cta"
            onClick={() => {
              if (openCart) {
                router.push(`${ROUTES.CART_CHANGE}/${openCart.orderFormId}`)
              } else {
                router.push(ROUTES.CLIENT_PROFILE)
              }
            }}
          >
            {isClientComplete(profile) || openCart ? (
              <FormattedMessage id="access" />
            ) : null}
          </div>
        </div>
      </div>
    )
  )
}

InsightsNotificationBar.propTypes = {
  profile: PropTypes.object,
  router: PropTypes.any,
  openCart: PropTypes.object,
}

export default injectIntl(InsightsNotificationBar)
